import styled from 'styled-components'

// Styled Components
export const LegendContainer = styled.div<{
  $position: string
  $isOpen: boolean
}>`
  position: relative;
  ${({ $position }) => {
    const [vertical, horizontal] = $position.split('-')
    return `
      ${vertical}: 300px;
      ${horizontal}: 20px;
    `
  }}
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  max-width: 300px;
  max-height: 300px;
  z-index: 1000;
  border: 1px solid #e0e0e0;

  /* Animation properties */
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transform: ${({ $isOpen }) =>
    $isOpen ? 'translateY(0)' : 'translateY(20px)'};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};

  @media (max-width: 768px) {
    min-width: 160px;
    max-width: 200px;
    padding: 12px;
    transform: ${({ $isOpen }) =>
      $isOpen ? 'translateY(0)' : 'translateY(15px)'};

    ${({ $position }) => {
      const [vertical, horizontal] = $position.split('-')
      return `
        ${vertical}: 10px;
        ${horizontal}: 10px;
      `
    }}
  }
`

export const LegendHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin-bottom: 12px;
`

export const LegendContent = styled.div<{ $isCollapsed: boolean }>`
  max-height: ${({ $isCollapsed }) => ($isCollapsed ? '0' : '160px')};
  opacity: ${({ $isCollapsed }) => ($isCollapsed ? 0 : 1)};
  overflow-y: ${({ $isCollapsed }) => ($isCollapsed ? 'hidden' : 'auto')};
  overflow-x: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #999;
  }

  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #ccc #f1f1f1;
`

export const LegendTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  flex: 1;
`

export const GradientLegend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const GradientBar = styled.div`
  height: 20px;
  border-radius: 4px;
  width: 100%;
`

export const GradientLabels = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const GradientLabel = styled.span`
  font-size: 11px;
  color: #6b6b6b;
`

export const LegendUnit = styled.div`
  font-size: 11px;
  color: #999;
  text-align: center;
  margin-top: 4px;
`

export const CategoricalLegend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const CategoricalItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ColorBox = styled.div<{ color: string }>`
  width: 20px;
  height: 20px;
  background: ${({ color }) => color};
  border-radius: 4px;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.1);
`

export const ItemLabel = styled.span`
  font-size: 12px;
  color: #1a1a1a;
`

export const WMSLegendImage = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  margin-top: 8px;
  display: block;

  &:hover {
    cursor: pointer;
  }
`
